/**
 * LoopRegionOverlay Component
 * Visual overlay showing loop region with draggable start/end markers
 */

import React from 'react';

export const LoopRegionOverlay = ({
  loopEnabled,
  loopStart,
  loopEnd,
  totalDuration,
  zoom,
  setIsDraggingLoopStart,
  setIsDraggingLoopEnd,
  loopDragStartRef,
}) => {
  if (!loopEnabled) return null;
  
  return (
    <>
      {/* Loop region background */}
      <div
        className="absolute top-0 bottom-0 bg-indigo-500/10 border-l-2 border-r-2 border-indigo-500/50 z-10 pointer-events-none"
        style={{
          left: `${(loopStart / totalDuration) * 100 * zoom}%`,
          width: `${((loopEnd - loopStart) / totalDuration) * 100 * zoom}%`,
        }}
      />
      
      {/* Loop Start Marker */}
      <div
        className="absolute top-0 bottom-0 w-1 bg-indigo-500 cursor-ew-resize z-30 hover:bg-indigo-400"
        style={{ left: `${(loopStart / totalDuration) * 100 * zoom}%` }}
        onMouseDown={(e) => {
          e.stopPropagation();
          setIsDraggingLoopStart(true);
          loopDragStartRef.current = { x: e.clientX, loopStart, loopEnd };
        }}
        data-testid="loop-start-marker"
      >
        <div className="absolute top-0 left-0 w-4 h-4 bg-indigo-500 rounded-br-lg flex items-center justify-center cursor-ew-resize">
          <span className="text-[8px] text-white font-bold">L</span>
        </div>
      </div>
      
      {/* Loop End Marker */}
      <div
        className="absolute top-0 bottom-0 w-1 bg-indigo-500 cursor-ew-resize z-30 hover:bg-indigo-400"
        style={{ left: `${(loopEnd / totalDuration) * 100 * zoom}%` }}
        onMouseDown={(e) => {
          e.stopPropagation();
          setIsDraggingLoopEnd(true);
          loopDragStartRef.current = { x: e.clientX, loopStart, loopEnd };
        }}
        data-testid="loop-end-marker"
      >
        <div className="absolute top-0 right-0 w-4 h-4 bg-indigo-500 rounded-bl-lg flex items-center justify-center cursor-ew-resize">
          <span className="text-[8px] text-white font-bold">R</span>
        </div>
      </div>
    </>
  );
};

export default LoopRegionOverlay;
